import AppConstants from '../constants/AppConstants';

export const initialState = {
    item: {},
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.CONVERSION_USER_INFO_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.CONVERSION_USER_INFO_SUCCESS:
            return {
                ...state,
                loading: true,
                item: action.item
            };

        case AppConstants.CONVERSION_USER_INFO_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.CONVERSION_USER_INFO_CLOSE:
            return {
                ...state,
                loading: true
            };

        case AppConstants.CONVERSION_USER_INFO_CLOSE_SUCCESS:
            return {
                ...state,
                item: {},
                loading: false
            };

        default:
            return state;
    }
};
